import { render } from "./how-we-work.vue?vue&type=template&id=7bf25843"
import script from "./how-we-work.vue?vue&type=script&lang=js"
export * from "./how-we-work.vue?vue&type=script&lang=js"

import "./how-we-work.vue?vue&type=style&index=0&id=7bf25843&lang=css"

import exportComponent from "/codebuild/output/src3474900079/src/relsify_nft_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__